'use strict';

import BaseService from './base.service';

class StatesTemplatesService extends BaseService {
  /* @ngInject */
  constructor(StatesTemplate, SegaUser) {
    super(StatesTemplate, SegaUser);
    Object.assign(this, {
      StatesTemplate
    });
  }
}

export default StatesTemplatesService;
